/** Stacked tables based on CodePen by Jacob Lett https://codepen.io/JacobLett/pen/mBQoOj*/
$(function() {
  $('.table-stacked').each(function(i) {
    const id = $(this).attr('id');
    $(this).find('th').each(function(i) {
      $('#'+ id + ' td:nth-child(' + (i + 1) + ')')
          .prepend('<span class="table-stacked-thead">' +
          $(this).text() + ':</span> ');
      $('.table-stacked-thead').hide();
    });
  });

  $('.table-stacked').each(function() {
    const thCount = $(this).find('th').length;
    const rowGrow = 100 / thCount + '%';
    $(this).find('th, td').css('flex-basis', rowGrow);
  });

  /** Flex table */
  function flexTable() {
    if ($(window).width() < 768) {
      $('.table-stacked').each(function(i) {
        $(this).find('.table-stacked-thead').show();
        $(this).find('th[scope="col"]').hide();
      });
    } else {
      $('.table-stacked').each(function(i) {
        $(this).find('.table-stacked-thead').hide();
        $(this).find('th[scope="col"]').show();
      });
    }
  }

  flexTable();

  window.onresize = function(event) {
    flexTable();
  };
});
